import { useMemo } from 'react'
import { useStateHooks } from '../../../../../state'
import { TableName } from '../../../../../tables'
import { Stock } from '../../../../stock'
import { Product } from '../../../../products'
import { Branch } from '../../../../manager'
import { WidgetCard } from '../widget-card/widgetCard'
import { RoutePath } from '../../../../../features/routes'
import styles from './criticalStockWidget.module.css'

type Props = {
    branches: Branch[]
    // Only the stock of a branch (e.g. for the warehouse role); all branches by default
    branchId?: string
}

export const CriticalStockWidget = (props: Props) => {
    const { branches, branchId } = props
    const { getList, find } = useStateHooks()

    const items = useMemo(() => {
        const allStock = getList(TableName.STOCK) as Stock[]
        const critical = allStock.filter(s => s.availableUnits <= 0 && (!branchId || s.branchId === branchId))
        return critical.map(s => {
            const product = find(TableName.PRODUCTS, s.productId) as Product | undefined
            const branch = branches.find(b => b.id === s.branchId)
            return {
                id: s.id,
                productName: product?.name || s.productId,
                branchName: branch?.name || s.branchId,
                units: s.availableUnits,
                negative: s.availableUnits < 0
            }
        })
    }, [branches, branchId])

    return (
        <WidgetCard
            title="Stock crítico"
            empty={items.length === 0}
            linkLabel="Ver stock"
            linkPath={RoutePath.STOCK}
        >
            <ul className={styles.list}>
                {items.slice(0, 6).map(item => (
                    <li key={item.id} className={styles.item}>
                        <span className={styles.productName}>{item.productName}</span>
                        <div className={styles.right}>
                            <span className={styles.branch}>{item.branchName}</span>
                            <span className={`${styles.badge} ${item.negative ? styles.negative : styles.zero}`}>
                                {item.units}
                            </span>
                        </div>
                    </li>
                ))}
                {items.length > 6 && (
                    <li className={styles.more}>+{items.length - 6} más</li>
                )}
            </ul>
        </WidgetCard>
    )
}
